import script from "./moviesOrActorItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./moviesOrActorItem.vue?vue&type=script&lang=ts&setup=true"

import "./moviesOrActorItem.vue?vue&type=style&index=0&id=0459bb54&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0459bb54"]])

export default __exports__